// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZfYt","top":"styles_top__27cUF"};